export default __webpack_public_path__ + "static/media/element_16.4389bdd4.webp";